import { setCookie, deleteCookie } from "@litres/utils";
import type { ESafemode } from "../constants";

export const setSafeModeCookie = (value: ESafemode) => {
  const expires = new Date();
  expires.setFullYear(expires.getFullYear() + 1);

  setCookie("safemode", value.toString(), {
    expires,
  });
};

export const deleteSafeModeCookie = () => {
  deleteCookie("safemode");
};
